import * as XLSX from 'xlsx';

// Выгрузка данных графика «История расходов тестов» со страницы менеджеров.
export default class ManagerStatsToTable {
  constructor({
    tests, totalSent, managerName, period,
  }) {
    this.tests = tests || [];
    this.totalSent = totalSent || 0;
    this.managerName = managerName;
    this.period = period;
  }

  toTable() {
    const data = [
      ['Менеджер', this.managerName],
      ['Период', this.period],
      [],
      ['Тест', 'Израсходовано'],
      ...this.tests.map((test) => [test.test_name, test.count]),
      ['Всего', this.totalSent],
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    ws['!cols'] = [
      { wch: 35 },
      { wch: 30 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Расход тестов');

    XLSX.writeFile(wb, 'История расходов тестов.xlsx');
  }
}
